import { render, staticRenderFns } from "./scanCode.vue?vue&type=template&id=88487858&scoped=true&"
import script from "./scanCode.vue?vue&type=script&lang=js&"
export * from "./scanCode.vue?vue&type=script&lang=js&"
import style0 from "./scanCode.vue?vue&type=style&index=0&id=88487858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88487858",
  null
  
)

export default component.exports